import React from 'react'
import ContextMenuItem from './ContextMenuItem'
import { AFFICHER_VILLE } from './contextmenu.constants'
import { useT } from '../../i18n/T'
import { useAction, withEverySelectorTruthy } from '../../utils/react-redux'
import { searchCityFromPoint } from '../../../store/address/address.actions'
import { selectIsPlacesUniverse } from '../../../store/history/history.selectors'

const ContextMenuItemShowCity = () => {
  const label = useT('map.context-menu.show-city')
  const execSearchLocation = useAction(searchCityFromPoint)

  return <ContextMenuItem tagAction={AFFICHER_VILLE} label={label} clickAction={execSearchLocation} />
}

export default withEverySelectorTruthy(selectIsPlacesUniverse)(ContextMenuItemShowCity)
